import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[validateEmail][formControlName],[validateEmail][formControl],[validateEmail][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EmailValidatorDirective),
            multi: true,
        },
    ],
})
export class EmailValidatorDirective implements Validator
{
    public validate(control: AbstractControl): { [key: string]: any } {
        if (!control || !control.value) {
            return null;
        }

        const regex = /^([\w!#\$%&'\*\+-\/=\?\^`\{\|}~]+\.)*[\w!#\$%&'\*\+-\/=\?\^`\{\|}~]+@((((([\w][\w\-]{0,62}[\w])|[a-zA-Z])\.)+[a-zA-Z]{2,6})|(\d{1,3}\.){3}\d{1,3}(:\d{1,5})?)$/i;

        if (!regex.test(control.value)) {
            return {emailInvalid: true};
        }

        return null;
    }
}
